import { Component, OnInit, OnDestroy, inject, effect, DestroyRef } from '@angular/core';
import { Router } from '@angular/router';
import { CoreService } from '../../services/core.service';
import { PracticeStore } from '../../state';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {

    private coreService = inject(CoreService);
    private practiceStore = inject(PracticeStore);
    private router = inject(Router);

    readonly window = window;

    constructor() {
      // React to practice store loaded signal — navigate when data is ready
      effect(() => {
        const loaded = this.practiceStore.loaded();
        if (loaded) {
          this.navigate();
        }
      });
    }

    ngOnInit(): void {
      // If already ready (cache hit), navigate immediately
      if (this.coreService.hasPractices()) {
        this.navigate();
      }
    }

    private navigate() {
      if (this.coreService.hasPractices()) {
        this.router.navigateByUrl('dashboard');
      } else if (this.coreService.hasInvites()) {
        this.router.navigateByUrl('invites');
      } else {
        this.router.navigateByUrl('error');
      }
    }
}
